<script>
import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  props: {
    data: {
      type: Array,
      required: true,
    },
    label: {
      type: Array,
      required: true,
    },
  },
  watch: {
    data() {
      this.render();
      this.loading = false;
    },
  },
  mounted() {
    this.loading = true;
  },
  methods: {
    render() {
      this.renderChart(
        {
          labels: this.label,
          datasets: [
            {
              label: this.label,
              backgroundColor: ['#22a7f0', '#e05d6f', '#01c1c1', '#ffcf07', '#b770e3'],
              data: this.data,
            },
          ],
        },
        {
          responsive: false,
          maintainAspectRatio: false,
          legend: {
            display: false,
            labels: {
              padding: 30,
            },
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            }],
            xAxes: [{
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: false,
              },
            }],
          },
        },

      );
    },
  },
};
</script>
